import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngxs/store';
import { Observable, Subject, delay, firstValueFrom, map, takeUntil } from 'rxjs';

import { Experience } from '@hiptraveler/data-access/api';
import { BrandState } from '@hiptraveler/data-access/brand';
import { RegistrationFormStateService } from '../common';

function getExperiences(experiences: Partial<Experience>[] | null): Partial<Experience>[] {
  return experiences?.filter(e => e.category === 'activity') || [];
}

@Injectable()
export class ActivitiesService {

  subscription$ = new Subject<void>();

  constructor(
    private store: Store,
    public stateService: RegistrationFormStateService
  ) { }

  get formValue(): string[] {
    return this.stateService.subCategoriesForm.value;
  }

  get formValue$(): Observable<string[]> {
    return this.stateService.subCategoriesForm.valueChanges.pipe(
      delay(0),
      takeUntil(this.subscription$)
    );
  }

  get experiences$(): Observable<Partial<Experience>[]> {
    return this.store.select(BrandState.experiences).pipe(
      map(experiences => experiences || []),
      takeUntil(this.subscription$)
    );
  }

  get experiences(): Promise<Partial<Experience>[]> {
    return firstValueFrom(this.experiences$);
  }

  initializeFormObserver(): void {
    this.stateService.initializeFormObserver(() => this.subscription$.next());
  }

  addActivity(selection: string): void {
    const experiences = getExperiences(this.store.selectSnapshot(BrandState.experiences));
    const selectionIndex = experiences.map(e => e.code).indexOf(selection);
    const code = experiences[selectionIndex].code;
    code && this.appendActivityToForm(code);
  }

  removeActivity(selection: string): void {
    const index = this.formValue.indexOf(selection);
    this.stateService.subCategoriesForm.removeAt(index);
  }

  appendActivityToForm(code: string): void {
    this.stateService.subCategoriesForm.push(
      new FormControl(code)
    );
  }

}
